import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import './AdminPlans.css';
import adminApiService from './AdminApiService';

const AdminPlans = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingPlan, setEditingPlan] = useState(null);
  const [availableRoles, setAvailableRoles] = useState([]);
  const [planRoles, setPlanRoles] = useState([]);
  const [loadingRoles, setLoadingRoles] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    slug: '',
    description: '',
    price: '',
    billing_cycle: 'monthly',
    trial_days: 0,
    max_users: '',
    max_projects: '',
    max_storage_gb: '',
    is_active: true,
    is_popular: false,
    display_order: 0,
    max_vendors:0
  });

  useEffect(() => {
    fetchPlans();
  }, []);

  const fetchPlans = async () => {
    try {
      // const token = localStorage.getItem('adminToken');
      // const response = await axios.get('http://localhost:5001/api/v1/admin/plans', {
      //   headers: { Authorization: `Bearer ${token}` }
      // });

      const response = await adminApiService.getAllPlans()
      console.log("response", response?.plans)

      setPlans(response?.plans || []);
    } catch (error) {
      console.error('Error fetching plans:', error);
      toast.error('Failed to load subscription plans');
    } finally {
      setLoading(false);
    }
  };

  const fetchAvailableRoles = async () => {
    try {
      // const token = localStorage.getItem('adminToken');
      // const response = await axios.get('http://localhost:5001/api/v1/admin/plans/roles/available', {
      //   headers: { Authorization: `Bearer ${token}` }
      // });
      const response = await adminApiService.getAllRoles()


      setAvailableRoles(response.roles || []);
    } catch (error) {
      console.error('Error fetching available roles:', error);
      toast.error('Failed to load available roles');
    }
  };

  const fetchPlanRoles = async (planId) => {
    setLoadingRoles(true);
    try {
      // const token = localStorage.getItem('adminToken');
      // const response = await axios.get(`http://localhost:5001/api/v1/admin/plans/${planId}/roles`, {
      //   headers: { Authorization: `Bearer ${token}` }
      // });

      const response = await adminApiService.getAllRolesById(planId)

      setPlanRoles(response.roles || []);
    } catch (error) {
      console.error('Error fetching plan roles:', error);
      toast.error('Failed to load plan roles');
    } finally {
      setLoadingRoles(false);
    }
  };

  const addRoleToPlan = async (roleName) => {
    if (!editingPlan) return;

    try {
      const token = localStorage.getItem('adminToken');
      await axios.post(
        `http://localhost:5001/api/v1/admin/plans/${editingPlan.id}/roles`,
        { roleName },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success(`${roleName} added to plan`);
      await fetchPlanRoles(editingPlan.id);
    } catch (error) {
      console.error('Error adding role:', error);
      toast.error(error.response?.data?.error || 'Failed to add role');
    }
  };

  const removeRoleFromPlan = async (roleId, roleName) => {
    if (!editingPlan) return;

    if (!window.confirm(`Remove ${roleName} from this plan?`)) return;

    try {
      const token = localStorage.getItem('adminToken');
      await axios.delete(
        `http://localhost:5001/api/v1/admin/plans/${editingPlan.id}/roles/${roleId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success(`${roleName} removed from plan`);
      await fetchPlanRoles(editingPlan.id);
    } catch (error) {
      console.error('Error removing role:', error);
      toast.error(error.response?.data?.error || 'Failed to remove role');
    }
  };

  const openEditModal = async (plan) => {
    setEditingPlan(plan);
    setFormData({
      name: plan.name || '',
      slug: plan.slug || '',
      description: plan.description || '',
      price: plan.price || '',
      billing_cycle: plan.billing_cycle || 'monthly',
      trial_days: plan.trial_days || 0,
      max_users: plan.max_users || '',
      max_projects: plan.max_projects || '',
      max_storage_gb: plan.max_storage_gb || '',
      is_active: plan.is_active !== undefined ? plan.is_active : true,
      is_popular: plan.is_popular || false,
      display_order: plan.display_order || 0
    });
    setShowEditModal(true);

    // Fetch available roles and plan roles
    await fetchAvailableRoles();
    await fetchPlanRoles(plan.id);
  };

  const closeEditModal = () => {
    setShowEditModal(false);
    setEditingPlan(null);
    setPlanRoles([]);
    setAvailableRoles([]);
    setFormData({
      name: '',
      slug: '',
      description: '',
      price: '',
      billing_cycle: 'monthly',
      trial_days: 0,
      max_users: '',
      max_projects: '',
      max_storage_gb: '',
      is_active: true,
      is_popular: false,
      display_order: 0,
      max_vendors:0
    });
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!editingPlan) return;

    try {
      const token = localStorage.getItem('adminToken');

      // Prepare data - convert empty strings to null for numeric fields
      const updateData = {
        ...formData,
        price: parseFloat(formData.price) || 0,
        trial_days: parseInt(formData.trial_days) || 0,
        max_users: formData.max_users ? parseInt(formData.max_users) : null,
        max_projects: formData.max_projects ? parseInt(formData.max_projects) : null,
        max_storage_gb: formData.max_storage_gb ? parseInt(formData.max_storage_gb) : null,
        display_order: parseInt(formData.display_order) || 0
      };

      await axios.put(
        `http://localhost:5001/api/v1/admin/plans/${editingPlan.id}`,
        updateData,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      toast.success('Plan updated successfully');
      closeEditModal();
      fetchPlans();
    } catch (error) {
      console.error('Error updating plan:', error);
      toast.error(error.response?.data?.error || 'Failed to update plan');
    }
  };

  const toggleStatus = async (id, currentStatus) => {
    try {
      const token = localStorage.getItem('adminToken');
      await axios.patch(
        `http://localhost:5000/api/v1/admin/plans/${id}`,
        { is_active: !currentStatus },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success('Plan status updated');
      fetchPlans();
    } catch (error) {
      console.error('Error updating plan:', error);
      toast.error('Failed to update plan');
    }
  };

  const filteredPlans = plans.filter(plan => {
    const matchesFilter = filter === 'all' ||
      (filter === 'active' && plan.is_active) ||
      (filter === 'inactive' && !plan.is_active);
    const matchesSearch =
      plan.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      plan.description?.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesFilter && matchesSearch;
  });

  const formatPrice = (price, currency = 'INR') => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: currency,
    }).format(price);
  };

  if (loading) {
    return <div className="admin-plans"><div className="loading">Loading...</div></div>;
  }

  return (
    <div className="admin-plans">
      <div className="page-header">
        <h1>Subscription Plans</h1>
        <div className="header-stats">
          <div className="stat-card">
            <span className="stat-label">Total Plans</span>
            <span className="stat-value">{plans.length}</span>
          </div>
          <div className="stat-card">
            <span className="stat-label">Active</span>
            <span className="stat-value">{plans.filter(p => p.is_active).length}</span>
          </div>
          <div className="stat-card">
            <span className="stat-label">Inactive</span>
            <span className="stat-value">{plans.filter(p => !p.is_active).length}</span>
          </div>
        </div>
      </div>

      <div className="filters-section">
        <div className="search-box">
          <input
            type="text"
            placeholder="Search by name or description..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="filter-buttons">
          <button
            className={filter === 'all' ? 'active' : ''}
            onClick={() => setFilter('all')}
          >
            All
          </button>
          <button
            className={filter === 'active' ? 'active' : ''}
            onClick={() => setFilter('active')}
          >
            Active
          </button>
          <button
            className={filter === 'inactive' ? 'active' : ''}
            onClick={() => setFilter('inactive')}
          >
            Inactive
          </button>

          <button
            className='active'
            onClick={() => setFilter('inactive')}
          >
            Add Plan
          </button>
        </div>
      </div>

      <div className="plans-grid">
        {filteredPlans.length === 0 ? (
          <div className="no-data">No subscription plans found</div>
        ) : (
          filteredPlans.map(plan => (
            <div key={plan.id} className={`plan-card ${!plan.is_active ? 'inactive' : ''}`}>
              <div className="plan-header">
                <h3>{plan.name}</h3>
                <span className={`status-badge ${plan.is_active ? 'badge-success' : 'badge-danger'}`}>
                  {plan.is_active ? 'Active' : 'Inactive'}
                </span>
              </div>

              <div className="plan-price">
                <span className="price">{formatPrice(plan.price, plan.currency)}</span>
                <span className="billing-cycle">/{plan.billing_cycle}</span>
              </div>

              <p className="plan-description">{plan.description || 'No description available'}</p>

              <div className="plan-features">
                <h4>Features:</h4>
                <ul>
                  {plan.features && typeof plan.features === 'object' ? (
                    Object.entries(plan.features).map(([key, value]) => (
                      <li key={key}>
                        <span className="feature-name">{key.replace(/_/g, ' ')}:</span>
                        <span className="feature-value">{String(value)}</span>
                      </li>
                    ))
                  ) : (
                    <li>No features listed</li>
                  )}
                </ul>
              </div>

              {plan.roleConfigurations && (
                <div className="plan-roles">
                  <h4>Included Roles ({plan.roleConfigurations.count}):</h4>
                  <div className="roles-list">
                    {plan.roleConfigurations.roles.map((role, index) => (
                      <div key={index} className="role-item">
                        <div className="role-header">
                          <span className="role-name">{role.name}</span>
                          <span className="role-permissions">{role.permissionCount} permissions</span>
                        </div>
                        <p className="role-description">{role.description}</p>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div className="plan-limits">
                <div className="limit-item">
                  <span className="limit-label">Max Users:</span>
                  <span className="limit-value">{plan.max_users || 'Unlimited'}</span>
                </div>
                <div className="limit-item">
                  <span className="limit-label">Max Projects:</span>
                  <span className="limit-value">{plan.max_projects || 'Unlimited'}</span>
                </div>
                <div className="limit-item">
                  <span className="limit-label">Storage:</span>
                  <span className="limit-value">{plan.storage_limit ? `${plan.storage_limit} GB` : 'Unlimited'}</span>
                </div>
              </div>

              <div className="plan-footer">
                <div className="plan-actions">
                  <button
                    className="btn-edit"
                    onClick={() => openEditModal(plan)}
                    title="Edit Plan"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                    </svg>
                    Edit
                  </button>
                  <button
                    className={plan.is_active ? 'btn-deactivate' : 'btn-activate'}
                    onClick={() => toggleStatus(plan.id, plan.is_active)}
                  >
                    {plan.is_active ? 'Deactivate' : 'Activate'}
                  </button>
                </div>
                <div className="plan-meta">
                  <small>Created: {new Date(plan.created_at).toLocaleDateString()}</small>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Edit Modal */}
      {showEditModal && (
        <div className="modal-overlay" onClick={closeEditModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2 style={{color:'#fff'}}>Edit Subscription Plan</h2>
              <button className="modal-close" onClick={closeEditModal}>&times;</button>
            </div>

            <form onSubmit={handleSubmit} className="modal-form">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="form-group">
                  <label htmlFor="name">Plan Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="slug">Slug *</label>
                  <input
                    type="text"
                    id="slug"
                    name="slug"
                    value={formData.slug}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="description">Description</label>
                <textarea
                  id="description"
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  rows="3"
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="form-group">
                  <label htmlFor="price">Price *</label>
                  <input
                    type="number"
                    id="price"
                    name="price"
                    value={formData.price}
                    onChange={handleInputChange}
                    step="0.01"
                    min="0"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="billing_cycle">Billing Cycle *</label>
                  <select
                    id="billing_cycle"
                    name="billing_cycle"
                    value={formData.billing_cycle}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="monthly">Monthly</option>
                    <option value="quarterly">Quarterly</option>
                    <option value="yearly">Yearly</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="trial_days">Trial Days</label>
                  <input
                    type="number"
                    id="trial_days"
                    name="trial_days"
                    value={formData.trial_days}
                    onChange={handleInputChange}
                    min="0"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="form-group">
                  <label htmlFor="max_users">Max Users</label>
                  <input
                    type="number"
                    id="max_users"
                    name="max_users"
                    value={formData.max_users}
                    onChange={handleInputChange}
                    min="1"
                    placeholder="Leave empty for unlimited"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="max_projects">Max Projects</label>
                  <input
                    type="number"
                    id="max_projects"
                    name="max_projects"
                    value={formData.max_projects}
                    onChange={handleInputChange}
                    min="1"
                    placeholder="Leave empty for unlimited"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="max_storage_gb">Storage (GB)</label>
                  <input
                    type="number"
                    id="max_storage_gb"
                    name="max_storage_gb"
                    value={formData.max_storage_gb}
                    onChange={handleInputChange}
                    min="1"
                    placeholder="Leave empty for unlimited"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="form-group">
                  <label htmlFor="max_vendors">Max Clients</label>
                  <input
                    type="number"
                    id="max_vendors"
                    name="max_vendors"
                    value={formData.max_vendors}
                    onChange={handleInputChange}
                    min="0"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="display_order">Display Order</label>
                  <input
                    type="number"
                    id="display_order"
                    name="display_order"
                    value={formData.display_order}
                    onChange={handleInputChange}
                    min="0"
                  />
                </div>
              </div>

              <div className="checkbox-row">
                <div className="form-group checkbox-group">
                  <label>
                    <input
                      type="checkbox"
                      name="is_active"
                      checked={formData.is_active}
                      onChange={handleInputChange}
                    />
                    <span>Active</span>
                  </label>
                </div>

                <div className="form-group checkbox-group">
                  <label>
                    <input
                      type="checkbox"
                      name="is_popular"
                      checked={formData.is_popular}
                      onChange={handleInputChange}
                    />
                    <span>Popular</span>
                  </label>
                </div>
              </div>

              {/* Role Management Section */}
              <div className="roles-management-section">
                <h4>Manage Roles</h4>
                <p className="section-description">
                  Add or remove roles for this subscription plan. Custom roles override the default plan-based roles.
                </p>

                {loadingRoles ? (
                  <div className="loading-roles">Loading roles...</div>
                ) : (
                  <>
                    {/* Current Plan Roles */}
                    <div className="current-roles">
                      <h5>Current Roles ({planRoles.length})</h5>
                      <div className="roles-list-manage">
                        {planRoles.length === 0 ? (
                          <p className="no-roles">No custom roles added. Using default roles based on plan name.</p>
                        ) : (
                          planRoles.map((role) => (
                            <div key={role.id || role.name} className="role-manage-card">
                              <div className="role-manage-info">
                                <span className="role-manage-name">{role.name}</span>
                                <span className="role-manage-badge">{role.permissionCount} permissions</span>
                              </div>
                              <button
                                type="button"
                                className="btn-remove-role"
                                onClick={() => removeRoleFromPlan(role.id, role.name)}
                                title="Remove role"
                              >
                                ×
                              </button>
                            </div>
                          ))
                        )}
                      </div>
                    </div>

                    {/* Available Roles to Add */}
                    <div className="available-roles">
                      <h5>Add Roles</h5>
                      <div className="roles-grid-add">
                        {availableRoles.map((role) => {
                          const isAdded = planRoles.some(pr => pr.name === role.name);
                          return (
                            <button
                              key={role.name}
                              type="button"
                              className={`role-add-card ${isAdded ? 'added' : ''}`}
                              onClick={() => !isAdded && addRoleToPlan(role.name)}
                              disabled={isAdded}
                              title={isAdded ? 'Already added' : `Add ${role.name}`}
                            >
                              <div className="role-add-header">
                                <span className="role-add-name">{role.name}</span>
                                {isAdded && <span className="checkmark">✓</span>}
                              </div>
                              <p className="role-add-desc">{role.description}</p>
                              <span className="role-add-permissions">{role.permissionCount} permissions</span>
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  </>
                )}
              </div>

              <div className="modal-footer">
                <button type="button" className="btn-cancel" onClick={closeEditModal}>
                  Cancel
                </button>
                <button type="submit" className="btn-save">
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminPlans;


